const translationsIt = {
    priceCalculator: {
        ExternalWashingTitle: "Lavaggio esterno",
        ExternalWashingDescription: "Pulizia della carrozzeria esterna, pulizia vetri, pulizia cerchioni, applicazione nero gomme.",
        InternalWashingTitle: "Lavaggio interno",
        InternalWashingDescription: "Aspirazione dell’abitacolo, pulizia dei cruscotti e dei vetri interni.",
        SanitationTitle: "Igienizzazione",
        SanitationDescription: "Disinfezione delle superifici e purificazione dell'aria dell'impianto di condizionamento.",
        GlassShieldTitle: "Protezione parabrezza",
        GlassShieldDescription: "Rivestimento che garantisce potere idrofobico e sigillante al parabrezza: favorisce lo scivolamento delle gocce di pioggia, consentendo di non utilizzare i tergicristalli sopra i 70 km/h.",
        GlassCoatingTitle: "Protezione parabrezza",
        GlassCoatingDescription: "Rivestimento che garantisce potere idrofobico e sigillante al parabrezza: favorisce lo scivolamento delle gocce di pioggia, consentendo di non utilizzare i tergicristalli sopra i 70 km/h.",
        PolishingTitle: "Polish",
        PolishingDescription: "Applicazione di una cera polish che aumenta la lucentezza della carrozzeria a fine lavaggio.",
        CeramicCoatingTitle: "Rivestimento ceramico",
        CeramicCoatingDescription: "Trattamento per ridare brillantezza alla carrozzeria, grazie alle proprietà idrorepellente aumenta la durata del lavaggio e conferisce setosità al tatto.",
        PremiumTyreDressingTitle: "Nero gomme premium",
        PremiumTyreDressingDescription: "Applicazione di un protettivo di alta qualità che ripristina l’aspetto “fresco di fabbrica” dei pneumatici per centinaia di chilometri.",
        EngineBayWashingTitle: "Lavaggio vano motore",
        EngineBayWashingDescription: "Cura del vano motore, rivolta alla pulizia delle parti ricoperte da polvere e grasso.",
        pageTitle: "Dove vuoi prenotare il lavaggio?",
        selectCityPlaceholder: "Seleziona la città",
        selectModelTitle: "Seleziona il modello del tuo veicolo ed scopri quanto costa lavarlo",
        selectBrandPlaceholder: "Seleziona la marca",
        selectModelPlaceholder: "Seleziona il modello",
        servicesNotSelectedInfo: "Per continuare inserisci i dati del tuo veicolo",
        baseServicesTitle: "Scegli i servizi che vuoi",
        premiumServicesTitle: "Aggiungi servizi premium (facoltativo)",
        washingDurationMessage: "Il tuo lavaggio avrà una durata di circa {0} minuti",
        genericScooterBrandModel: "Qualsiasi",
        baseServicesMissingWarningTitle: "Servizio base mancante!",
        baseServicesMissingWarningBody: "E' necessario selezionare prima uno dei servizi base.",
        noServicesCombinationWarningTitle: "Combinazione non prevista!",
        noServicesCombinationWarningBody: "Non è possibile determinare il prezzo aggiungendo questo servizio alla combinazione.",
        durationWarningTitle: "La durata del lavaggio potrebbe variare a seconda della condizione della vettura",
        resetSearch: "Nuova Ricerca",
        title: "I prezzi del lavaggio con Wash Out",
        subtitle: "Per scoprire il costo del lavaggio a domicilio del tuo veicolo, utilizza il menù qui in basso: lavaggio interno, esterno, igienizzazione e servizi premium.",
        salesForceName: "Nome",
        salesForceSurname: "Cognome",
        salesForceEmail: "Email",
        salesForcePhone: "Telefono",
        salesForceCompany: "Azienda",
        salesForceProvince: "Provincia",
        salesForceMessage: "Messaggio",
        salesForceSubmit: "Invia"
    },
    areas: {
        title: "Aree di copertura Wash Out",
        subtitle: "Scopri le aree di copertura per ogni città",
        milanoText: "Milano",
        romaText: "Roma",
        torinoText: "Torino",
        parigiText: "Parigi",
    },
    cities: {
        title: "Scopri le città in cui è attivo il servizio",
        searchPlaceholder: "Verifica se il tuo indirizzo è coperto",
        milanoText: "Milano",
        romaText: "Roma",
        torinoText: "Torino",
        parigiText: "Parigi",
        noResultsText: "Ci dispiace, l’indirizzo selezionato non è coperto dal servizio",
        noResultsButtonText: "Scopri le città attive",
        resultsText: "L’indirizzo è coperto dal servizio, prenota subito!",
        resultsButtonText: "Prenota un lavaggio"
    }
};